<script setup lang="ts">
	import { useAuthStore } from '@/stores/auth.ts';
	import { MzButton } from '@monizze/monizze-components';
	import router from '@/router';
	import { useI18n } from 'vue-i18n';

	const authStore = useAuthStore();
	const { t } = useI18n();

	const logout = async (): Promise<void> => {
		authStore.logout();
		await router.push('/');
	};
</script>

<template>
	<div v-if="authStore.isLogged">
		<mz-button variant="outline" :label="t('logout')" class="inline-block" @click="logout" />
	</div>
</template>
